// extracted by mini-css-extract-plugin
export var container = "InvestorList-module--container--da8a9";
export var m2Xl = "InvestorList-module--m-2xl--4ffe2";
export var m2Xs = "InvestorList-module--m-2xs--3cf01";
export var m3Xl = "InvestorList-module--m-3xl--b2cac";
export var m3Xs = "InvestorList-module--m-3xs--86824";
export var m4Xl = "InvestorList-module--m-4xl--a1e42";
export var m5Xl = "InvestorList-module--m-5xl--77147";
export var m6Xl = "InvestorList-module--m-6xl--bfa4e";
export var m7Xl = "InvestorList-module--m-7xl--e3f6e";
export var m8Xl = "InvestorList-module--m-8xl--bd4e7";
export var mBase = "InvestorList-module--m-base--7f2e1";
export var mLg = "InvestorList-module--m-lg--471ad";
export var mMd = "InvestorList-module--m-md--64074";
export var mSm = "InvestorList-module--m-sm--a63eb";
export var mXl = "InvestorList-module--m-xl--4ec2c";
export var mXs = "InvestorList-module--m-xs--4184c";
export var mb2Xl = "InvestorList-module--mb-2xl--39040";
export var mb2Xs = "InvestorList-module--mb-2xs--e7b6c";
export var mb3Xl = "InvestorList-module--mb-3xl--bcb09";
export var mb3Xs = "InvestorList-module--mb-3xs--1538c";
export var mb4Xl = "InvestorList-module--mb-4xl--ed547";
export var mb5Xl = "InvestorList-module--mb-5xl--db93a";
export var mb6Xl = "InvestorList-module--mb-6xl--588f0";
export var mb7Xl = "InvestorList-module--mb-7xl--916ce";
export var mb8Xl = "InvestorList-module--mb-8xl--c2bde";
export var mbBase = "InvestorList-module--mb-base--1ac94";
export var mbLg = "InvestorList-module--mb-lg--fdb71";
export var mbMd = "InvestorList-module--mb-md--e96ef";
export var mbSm = "InvestorList-module--mb-sm--9d9f9";
export var mbXl = "InvestorList-module--mb-xl--0ce28";
export var mbXs = "InvestorList-module--mb-xs--91406";
export var ml2Xl = "InvestorList-module--ml-2xl--6e392";
export var ml2Xs = "InvestorList-module--ml-2xs--3f516";
export var ml3Xl = "InvestorList-module--ml-3xl--5371f";
export var ml3Xs = "InvestorList-module--ml-3xs--a4123";
export var ml4Xl = "InvestorList-module--ml-4xl--b142f";
export var ml5Xl = "InvestorList-module--ml-5xl--6c030";
export var ml6Xl = "InvestorList-module--ml-6xl--f3df1";
export var ml7Xl = "InvestorList-module--ml-7xl--52c87";
export var ml8Xl = "InvestorList-module--ml-8xl--d0a68";
export var mlBase = "InvestorList-module--ml-base--9dfaf";
export var mlLg = "InvestorList-module--ml-lg--739b0";
export var mlMd = "InvestorList-module--ml-md--f3a0c";
export var mlSm = "InvestorList-module--ml-sm--9ac1d";
export var mlXl = "InvestorList-module--ml-xl--1dc2b";
export var mlXs = "InvestorList-module--ml-xs--bf88b";
export var mr2Xl = "InvestorList-module--mr-2xl--9e20c";
export var mr2Xs = "InvestorList-module--mr-2xs--bf3ec";
export var mr3Xl = "InvestorList-module--mr-3xl--fa053";
export var mr3Xs = "InvestorList-module--mr-3xs--a93ce";
export var mr4Xl = "InvestorList-module--mr-4xl--5d64a";
export var mr5Xl = "InvestorList-module--mr-5xl--773a4";
export var mr6Xl = "InvestorList-module--mr-6xl--d307e";
export var mr7Xl = "InvestorList-module--mr-7xl--2e494";
export var mr8Xl = "InvestorList-module--mr-8xl--628b0";
export var mrBase = "InvestorList-module--mr-base--afd80";
export var mrLg = "InvestorList-module--mr-lg--2f199";
export var mrMd = "InvestorList-module--mr-md--42a2d";
export var mrSm = "InvestorList-module--mr-sm--e960c";
export var mrXl = "InvestorList-module--mr-xl--db327";
export var mrXs = "InvestorList-module--mr-xs--d37a0";
export var mt2Xl = "InvestorList-module--mt-2xl--1508b";
export var mt2Xs = "InvestorList-module--mt-2xs--29cf8";
export var mt3Xl = "InvestorList-module--mt-3xl--64ac3";
export var mt3Xs = "InvestorList-module--mt-3xs--5c007";
export var mt4Xl = "InvestorList-module--mt-4xl--f26a0";
export var mt5Xl = "InvestorList-module--mt-5xl--4e6d4";
export var mt6Xl = "InvestorList-module--mt-6xl--da981";
export var mt7Xl = "InvestorList-module--mt-7xl--279b8";
export var mt8Xl = "InvestorList-module--mt-8xl--75832";
export var mtBase = "InvestorList-module--mt-base--bbc09";
export var mtLg = "InvestorList-module--mt-lg--b22a7";
export var mtMd = "InvestorList-module--mt-md--685e5";
export var mtSm = "InvestorList-module--mt-sm--c452a";
export var mtXl = "InvestorList-module--mt-xl--e8990";
export var mtXs = "InvestorList-module--mt-xs--d7bdc";
export var p2Xl = "InvestorList-module--p-2xl--1090b";
export var p2Xs = "InvestorList-module--p-2xs--3be93";
export var p3Xl = "InvestorList-module--p-3xl--7367d";
export var p3Xs = "InvestorList-module--p-3xs--ed2de";
export var p4Xl = "InvestorList-module--p-4xl--6205d";
export var p5Xl = "InvestorList-module--p-5xl--053cd";
export var p6Xl = "InvestorList-module--p-6xl--8b73a";
export var p7Xl = "InvestorList-module--p-7xl--1fc79";
export var p8Xl = "InvestorList-module--p-8xl--bfa66";
export var pBase = "InvestorList-module--p-base--b0308";
export var pLg = "InvestorList-module--p-lg--112a2";
export var pMd = "InvestorList-module--p-md--1876d";
export var pSm = "InvestorList-module--p-sm--3bf24";
export var pXl = "InvestorList-module--p-xl--03304";
export var pXs = "InvestorList-module--p-xs--baf3b";
export var pb2Xl = "InvestorList-module--pb-2xl--8a752";
export var pb2Xs = "InvestorList-module--pb-2xs--ab5fa";
export var pb3Xl = "InvestorList-module--pb-3xl--3cc8a";
export var pb3Xs = "InvestorList-module--pb-3xs--9323d";
export var pb4Xl = "InvestorList-module--pb-4xl--c0cab";
export var pb5Xl = "InvestorList-module--pb-5xl--4ce76";
export var pb6Xl = "InvestorList-module--pb-6xl--3a80c";
export var pb7Xl = "InvestorList-module--pb-7xl--7a881";
export var pb8Xl = "InvestorList-module--pb-8xl--9734e";
export var pbBase = "InvestorList-module--pb-base--4b1bf";
export var pbLg = "InvestorList-module--pb-lg--87da0";
export var pbMd = "InvestorList-module--pb-md--35b6c";
export var pbSm = "InvestorList-module--pb-sm--d4875";
export var pbXl = "InvestorList-module--pb-xl--1bee1";
export var pbXs = "InvestorList-module--pb-xs--14d71";
export var pl2Xl = "InvestorList-module--pl-2xl--a89a2";
export var pl2Xs = "InvestorList-module--pl-2xs--ec83b";
export var pl3Xl = "InvestorList-module--pl-3xl--efeb4";
export var pl3Xs = "InvestorList-module--pl-3xs--4f827";
export var pl4Xl = "InvestorList-module--pl-4xl--99862";
export var pl5Xl = "InvestorList-module--pl-5xl--e53b2";
export var pl6Xl = "InvestorList-module--pl-6xl--a815c";
export var pl7Xl = "InvestorList-module--pl-7xl--8bda5";
export var pl8Xl = "InvestorList-module--pl-8xl--5e62c";
export var plBase = "InvestorList-module--pl-base--d82a8";
export var plLg = "InvestorList-module--pl-lg--7b791";
export var plMd = "InvestorList-module--pl-md--bb409";
export var plSm = "InvestorList-module--pl-sm--1e6cf";
export var plXl = "InvestorList-module--pl-xl--395d9";
export var plXs = "InvestorList-module--pl-xs--965fd";
export var pr2Xl = "InvestorList-module--pr-2xl--59979";
export var pr2Xs = "InvestorList-module--pr-2xs--718b5";
export var pr3Xl = "InvestorList-module--pr-3xl--463d9";
export var pr3Xs = "InvestorList-module--pr-3xs--6b3d5";
export var pr4Xl = "InvestorList-module--pr-4xl--accfe";
export var pr5Xl = "InvestorList-module--pr-5xl--c9611";
export var pr6Xl = "InvestorList-module--pr-6xl--d70aa";
export var pr7Xl = "InvestorList-module--pr-7xl--d4166";
export var pr8Xl = "InvestorList-module--pr-8xl--1f146";
export var prBase = "InvestorList-module--pr-base--15a0f";
export var prLg = "InvestorList-module--pr-lg--44d3b";
export var prMd = "InvestorList-module--pr-md--5370e";
export var prSm = "InvestorList-module--pr-sm--d0127";
export var prXl = "InvestorList-module--pr-xl--95491";
export var prXs = "InvestorList-module--pr-xs--2603e";
export var pt2Xl = "InvestorList-module--pt-2xl--e842b";
export var pt2Xs = "InvestorList-module--pt-2xs--6e869";
export var pt3Xl = "InvestorList-module--pt-3xl--d7efa";
export var pt3Xs = "InvestorList-module--pt-3xs--d7a2e";
export var pt4Xl = "InvestorList-module--pt-4xl--0e353";
export var pt5Xl = "InvestorList-module--pt-5xl--46dc6";
export var pt6Xl = "InvestorList-module--pt-6xl--37b05";
export var pt7Xl = "InvestorList-module--pt-7xl--c7611";
export var pt8Xl = "InvestorList-module--pt-8xl--bc38d";
export var ptBase = "InvestorList-module--pt-base--caed0";
export var ptLg = "InvestorList-module--pt-lg--25778";
export var ptMd = "InvestorList-module--pt-md--17e44";
export var ptSm = "InvestorList-module--pt-sm--0b9c7";
export var ptXl = "InvestorList-module--pt-xl--28c9b";
export var ptXs = "InvestorList-module--pt-xs--937bf";